// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* notification icon */
.notification-menu-item {
  position: relative;
  display: none !important;
  /* NOTE: use class 'show' because active is already used for generic menu 
       items and show/hide mega menu, so we don't want to conflict with that */
  /* hide the desktop icon */
}
.notification-menu-item.show {
  display: flex !important;
  align-items: center;
  width: 50px;
  color: white;
  font-size: 22px;
  padding-top: 5px;
}
@media (min-width: 768px) {
  .notification-menu-item.show {
    /*margin-top: 5px;*/
  }
}
.notification-menu-item .notification-count {
  position: absolute;
  top: 2px;
  right: 24px;
  font-size: 10px;
  background: #d91e3e;
  padding: 3px 5px 5px 5px;
  border-radius: 50%;
  /*@media(max-width: @small-breakpoint) {
            top: 0;
            right: 8px;
        }*/
}
@media (max-width: 767px) {
  .notification-menu-item.menu-item-desktop {
    display: none !important;
  }
}
body .priority-message-container {
  /*top: 62px;*/
  transition: top 0.5s ease;
  /* @media(max-width: @small-breakpoint) {
            top: 50px;
        }*/
}
body.transparent .priority-message-container {
  /*top: 40px;*/
}
html.scrolled .priority-message-container {
  /*top: 55px;*/
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s ease;
}
html.scrolled .home-priority-messages .priority-message-container {
  visibility: visible;
  opacity: 1;
  transition: none;
}
.home-priority-messages {
  max-width: 840px;
  margin: 0 auto;
  margin-top: 40px;
}
.home-priority-messages .priority-message-container {
  position: relative !important;
  top: unset;
  right: unset;
  width: 100%;
  padding: 0 5px;
}
@media (max-width: 991px) {
  .home-priority-messages .priority-message-container {
    padding: 0 15px;
  }
}
.home-priority-messages .priority-message-container .priority-message {
  background: white;
  color: black;
  border: 1px solid #a0a0a0 !important;
  box-shadow: none;
  margin: 0 0 25px !important;
  opacity: 1 !important;
  visibility: visible !important;
  height: auto !important;
}
.home-priority-messages .priority-message-container .priority-message:before {
  display: none;
}
.home-priority-messages .priority-message-container .priority-message .priority-message-inner {
  padding: 15px 15px 5px;
}
.home-priority-messages .priority-message-container .priority-message .priority-message-close {
  display: none;
}
.priority-message-container {
  /*font-family: "Helvetica Neue Std Lt", "Helvetica Neue Roman", "Helvetica Neue Std Thin", "Helvetica Neue", Helvetica, Arial, sans-serif !important;*/
  display: block;
  position: absolute;
  max-width: 100%;
  top: 62px;
  right: 74px;
  width: 400px;
  background-color: transparent;
  z-index: 100;
}
@media (min-width: 525px) and (max-width: 767px) {
  .priority-message-container {
    width: 360px;
  }
}
@media (max-width: 525px) {
  .priority-message-container {
    width: 100% !important;
    right: 0;
    padding: 0 10px;
  }
}
.priority-message-container .priority-message {
  width: 100%;
  border: none;
  font-size: 16px;
  border-radius: 12px;
  box-shadow: 5px 5px 15px 0 rgba(0, 0, 0, 0.5);
  opacity: 0;
  height: 0;
  visibility: hidden;
  transition: opacity 0.1s ease-out;
  /*margin-left: .5rem;*/
  /*p {
                margin-bottom: 0 !important;
            }*/
  /*a {
                color: white !important;
                text-decoration: underline;
            }*/
}
.priority-message-container .priority-message.active {
  margin: 5px 0;
  background-color: white;
  opacity: 1;
  height: auto;
  visibility: visible;
  transition: opacity 0.2s ease-in, height 0.4s ease-in;
}
.priority-message-container .priority-message.active:before {
  content: "";
  position: absolute;
  top: -4px;
  right: 28px;
  /*right: 165px; <--- this is set above for port and flypdx navbars */
  height: 0;
  width: 0;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-bottom: 10px solid white;
}
@media (max-width: 525px) {
  .priority-message-container .priority-message.active:before {
    right: 102px;
  }
}
.priority-message-container .priority-message .priority-message-title {
  color: #006aa9;
  font-size: calc(1.275rem + 0.3vw);
  font-weight: 700;
  line-height: 1.2em;
  margin-bottom: 5px;
  margin-left: 1rem;
}
@media (min-width: 1200px) {
  .priority-message-container .priority-message .priority-message-title {
    font-size: 1.5rem;
  }
}
.priority-message-container .priority-message span {
  white-space: pre;
}
.priority-message-container .priority-message .priority-message-inner {
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  /*.priority-message-title {
                font-size: 18px;
                font-weight: bold;
                padding-left: 15px;
                text-transform: uppercase;
            }*/
}
@media (max-width: 767px) {
  .priority-message-container .priority-message .priority-message-inner {
    width: 100%;
  }
}
.priority-message-container .priority-message .priority-message-inner .priority-message-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.priority-message-container .priority-message .priority-message-inner .priority-message-icon {
  position: relative;
  margin: 0;
}
.priority-message-container .priority-message .priority-message-inner .priority-message-icon i {
  color: #d91e3e;
  font-size: 36px;
  /*margin-left: .5rem;*/
}
.priority-message-container .priority-message .priority-message-inner .priority-message-body {
  padding: 0;
}
.priority-message-container .priority-message .priority-message-inner .priority-message-body a {
  color: white !important;
  text-decoration: underline;
}
.priority-message-container .priority-message .priority-message-inner .priority-message-footer {
  text-align: center;
}
.priority-message-container .priority-message .priority-message-inner .priority-message-footer .priority-message-close {
  /*background: none;
                    border: none;*/
  /*&:after {
                        content: "X";
                    }*/
}
.secondary-message-container {
  padding: 0;
  /*@media(max-width: @small-breakpoint) {
        padding: 10px 0;
    }*/
}
.secondary-message-container .secondary-message-wrapper {
  border-radius: 12px;
  border: 1px solid #006aa9;
  background-color: rgba(201, 227, 237, 0.5);
  padding: 1rem 0.5rem 0.25rem;
  margin: 1rem 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: start;
  /*max-width: 700px;
        margin: 0 auto;*/
  /*@media(max-width: @small-breakpoint) {
            padding: 15px;
        }

        @media (max-width: 374px) {
            flex-direction: column;
            align-items: center;
        }*/
}
.secondary-message-container .secondary-message-wrapper .secondary-message-icon i {
  color: #d91e3e;
  font-size: 36px;
  margin-left: 0.5rem;
}
.secondary-message-container .secondary-message-wrapper .secondary-message {
  margin-left: 0.5rem;
  /*p {
                margin-bottom: 0 !important;
            }*/
  /*a {
                color: white !important;
                text-decoration: underline;
            }*/
}
.secondary-message-container .secondary-message-wrapper .secondary-message .title {
  color: #006aa9;
  font-size: calc(1.275rem + 0.3vw);
  font-weight: 700;
  line-height: 1.2em;
  margin-bottom: 0.5rem;
}
@media (min-width: 1200px) {
  .secondary-message-container .secondary-message-wrapper .secondary-message .title {
    font-size: 1.5rem;
  }
}
.secondary-message-container .secondary-message-wrapper .secondary-message span {
  white-space: pre;
}
`, "",{"version":3,"sources":["webpack://./wwwroot/lib/vips/css/components/priority-messages.less"],"names":[],"mappings":"AAAA,sBAAsB;AAQtB;EACI,kBAAA;EACA,wBAAA;EANF;8EAC4E;EAC5E,0BAA0B;AAC5B;AAMI;EACI,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAJR;AAMQ;EAAA;IAHJ,mBAAmB;EACrB;AACF;AAZA;EAmBQ,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EAJN;;;UAGQ;AACV;AAQI;EACI;IACI,wBAAA;EANV;AACF;AAUA;EARE,aAAa;EAWP,yBAAA;EATN;;UAEQ;AACV;AAaI;EAXF,aAAa;AACf;AAiBA;EAfE,aAAa;EAkBP,kBAAA;EACA,UAAA;EACA,yBAAA;AAhBR;AAWA;EAUY,mBAAA;EACA,UAAA;EACA,gBAAA;AAlBZ;AA0BA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AAxBJ;AAqBA;EAMQ,6BAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAxBR;AA0BQ;EAAA;IACI,eAAA;EAvBV;AACF;AASA;EAiBY,iBAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;EACA,uBAAA;AAvBZ;AAyBY;EACI,aAAA;AAvBhB;AAJA;EA+BgB,sBAAA;AAxBhB;AAPA;EAmCgB,aAAA;AAzBhB;AA+BA;EA7BE,sJAAsJ;EA+BpJ,cAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;AA7BJ;AA+BI;EAAA;IACI,YAAA;EA5BN;AACF;AA8BI;EAAA;IACI,sBAAA;IACA,QAAA;IACA,eAAA;EA3BN;AACF;AAQA;EAsBQ,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,6CAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,iCAAA;EA3BN,sBAAsB;EACtB;;cAEY;EACZ;;;cAGY;AACd;AAqBQ;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,qDAAA;AAnBZ;AAqBY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAnBd,oEAAoE;EAqBtD,SAAA;EACA,QAAA;EACA,oCAAA;EACA,mCAAA;EACA,+BAAA;AAnBhB;AAqBgB;EAAA;IACI,YAAA;EAlBlB;AACF;AApCA;EA4DY,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AArBZ;AAuBY;EAAA;IACI,iBAAA;EApBd;AACF;AAjDA;EAgFY,gBAAA;AA5BZ;AApDA;EAqFY,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EA9BV;;;;;cAKY;AACd;AA0BY;EAAA;IACI,WAAA;EAvBd;AACF;AAxEA;EAkGgB,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAvBhB;AAhFA;EA2GgB,kBAAA;EACA,SAAA;AAxBhB;AApFA;EA+GoB,cAAA;EACA,eAAA;EAxBlB,sBAAsB;AACxB;AAzFA;EAsHgB,UAAA;AA1BhB;AA5FA;EAyHoB,uBAAA;EACA,0BAAA;AA1BpB;AAhGA;EAqIgB,kBAAA;AAlChB;AAnGA;EAqGE;kCACgC;EAChC;;sBAEoB;AACtB;AAyCA;EACI,UAAA;EAvCF;;MAEI;AACN;AAmCA;EAOQ,mBAAA;EACA,yBAAA;EACA,0CAAA;EACA,4BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EAvCN;wBACsB;EACtB;;;;;;;UAOQ;AACV;AAcA;EAiCgB,cAAA;EACA,eAAA;EACA,mBAAA;AA5ChB;AASA;EAwCY,mBAAA;EA9CV;;cAEY;EACZ;;;cAGY;AACd;AADA;EA2CgB,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAvChB;AAyCgB;EAAA;IACI,iBAAA;EAtClB;AACF;AAbA;EA8DgB,gBAAA;AA9ChB","sourcesContent":["@icon-dir: \"https://cdn.portofportland.com/icons/\";\n@alert-red: rgb(217,30,62);\n@alert-title-color: rgb(0, 106, 169);\n\n@small-breakpoint: 767px;\n@x-small-breakpoint: 525px;\n\n/* notification icon */\n.notification-menu-item {\n    position: relative;\n    display: none !important;\n    /* NOTE: use class 'show' because active is already used for generic menu \n       items and show/hide mega menu, so we don't want to conflict with that */\n    &.show {\n        display: flex !important;\n        align-items: center;\n        width: 50px;\n        color: white;\n        font-size: 22px;\n        padding-top: 5px;\n\n        @media(min-width: 768px) {\n            /*margin-top: 5px;*/\n        }\n    }\n\n    .notification-count {\n        position: absolute;\n        top: 2px;\n        right: 24px;\n        font-size: 10px;\n        background: @alert-red;\n        padding: 3px 5px 5px 5px;   \n        border-radius: 50%;\n\n        /*@media(max-width: @small-breakpoint) {\n            top: 0;\n            right: 8px;\n        }*/\n    }\n    /* hide the desktop icon */\n    @media (max-width: @small-breakpoint) {\n        &.menu-item-desktop {\n            display: none !important;\n        }\n    }\n}\n\nbody {\n    .priority-message-container {\n        /*top: 62px;*/\n        transition: top .5s ease;\n\n       /* @media(max-width: @small-breakpoint) {\n            top: 50px;\n        }*/\n    }\n\n    &.transparent {\n        .priority-message-container {\n            /*top: 40px;*/\n        }\n    }\n}\n\nhtml.scrolled {\n    .priority-message-container {\n        /*top: 55px;*/\n        visibility: hidden;\n        opacity: 0;\n        transition: all .5s ease;\n    }\n\n    .home-priority-messages {\n        .priority-message-container {\n            visibility: visible;\n            opacity: 1;\n            transition: none;\n        }\n    }\n\n    .priority-message-container .priority-message.active:before {\n    }\n}\n\n.home-priority-messages {\n    max-width: 840px;\n    margin: 0 auto;\n    margin-top: 40px;\n\n    .priority-message-container {\n        position: relative !important;\n        top: unset;\n        right: unset;\n        width: 100%;\n        padding: 0 5px;\n\n        @media(max-width: 991px) {\n            padding: 0 15px;\n        }\n\n        .priority-message {\n            background: white;\n            color: black;\n            border: 1px solid #a0a0a0 !important;\n            box-shadow: none;\n            margin: 0 0 25px !important;\n            opacity: 1 !important;\n            visibility: visible !important;\n            height: auto !important;\n\n            &:before {\n                display: none;\n            }            \n\n            .priority-message-inner {\n                padding: 15px 15px 5px;\n            }\n\n            .priority-message-close {\n                display: none;\n            }\n        }\n    }\n}\n\n.priority-message-container {\n    /*font-family: \"Helvetica Neue Std Lt\", \"Helvetica Neue Roman\", \"Helvetica Neue Std Thin\", \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;*/\n    display: block;\n    position: absolute;\n    max-width: 100%;\n    top: 62px;\n    right: 74px;\n    width: 400px;\n    background-color: transparent;\n    z-index: 100;\n\n    @media(min-width: @x-small-breakpoint) and (max-width: @small-breakpoint) {\n        width: 360px;\n    }\n\n    @media(max-width: @x-small-breakpoint) {\n        width: 100% !important;\n        right: 0;\n        padding: 0 10px;\n    }\n\n    .priority-message {\n        width: 100%;\n        border: none;\n        font-size: 16px;\n        border-radius: 12px;\n        box-shadow: 5px 5px 15px 0 rgba(0,0,0,.5);\n        opacity: 0;\n        height: 0;\n        visibility: hidden;\n        transition: opacity .1s ease-out;\n\n        &.active {\n            margin: 5px 0; // leave this here so it doesn't take up space when not active (to match up with the arrow)\n            background-color: white;\n            opacity: 1;\n            height: auto;\n            visibility: visible;\n            transition: opacity .2s ease-in, height .4s ease-in;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                top: -4px;\n                right: 28px;\n                /*right: 165px; <--- this is set above for port and flypdx navbars */\n                height: 0;\n                width: 0;\n                border-right: 10px solid transparent;\n                border-left: 10px solid transparent;\n                border-bottom: 10px solid white;\n\n                @media(max-width: @x-small-breakpoint) {\n                    right: 102px;\n                }\n            }\n        }\n        /*margin-left: .5rem;*/\n\n        .priority-message-title {\n            color: @alert-title-color;\n            font-size: calc(1.275rem + .3vw);\n            font-weight: 700;\n            line-height: 1.2em;\n            margin-bottom: 5px;\n            margin-left: 1rem;\n\n            @media(min-width: 1200px) {\n                font-size: 1.5rem;\n            }\n        }\n        /*p {\n                margin-bottom: 0 !important;\n            }*/\n        /*a {\n                color: white !important;\n                text-decoration: underline;\n            }*/\n\n        span {\n            white-space: pre;\n        }\n\n        .priority-message-inner {\n            //display: none;\n            flex-direction: row;\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n            align-items: center;\n            width: 100%;\n            margin: 0 auto;\n            padding: 15px;\n\n            @media(max-width: @small-breakpoint) {\n                width: 100%;\n            }\n\n            .priority-message-header {\n                display: flex;\n                flex-direction: row;\n                flex-wrap: nowrap;\n                justify-content: flex-start;\n                align-items: center;\n                margin-bottom: 10px;\n            }\n\n            .priority-message-icon {\n                position: relative;\n                margin: 0;\n\n                i {\n                    color: @alert-red;\n                    font-size: 36px;\n                    /*margin-left: .5rem;*/\n                }\n            }\n\n            .priority-message-body {\n                padding: 0;\n\n                a {\n                    color: white !important;\n                    text-decoration: underline;\n                }\n            }\n            /*.priority-message-title {\n                font-size: 18px;\n                font-weight: bold;\n                padding-left: 15px;\n                text-transform: uppercase;\n            }*/\n\n            .priority-message-footer {\n                text-align: center;\n\n                .priority-message-close {\n                    /*background: none;\n                    border: none;*/\n                    /*&:after {\n                        content: \"X\";\n                    }*/\n                }\n            }\n        }\n    }\n}\n\n.secondary-message-container {\n    padding: 0;\n    /*@media(max-width: @small-breakpoint) {\n        padding: 10px 0;\n    }*/\n\n    .secondary-message-wrapper {\n        border-radius: 12px;\n        border: 1px solid #006aa9;\n        background-color: rgba(201,227,237,.5);\n        padding: 1rem .5rem .25rem;\n        margin: 1rem 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n        align-items: start;\n        /*max-width: 700px;\n        margin: 0 auto;*/\n        /*@media(max-width: @small-breakpoint) {\n            padding: 15px;\n        }\n\n        @media (max-width: 374px) {\n            flex-direction: column;\n            align-items: center;\n        }*/\n\n        > div {\n        }\n\n        .secondary-message-icon {\n\n            i {\n                color: @alert-red;\n                font-size: 36px;\n                margin-left: .5rem;\n            }\n        }\n\n        .secondary-message {\n            margin-left: .5rem;\n\n            .title {\n                color: @alert-title-color;\n                font-size: calc(1.275rem + .3vw);\n                font-weight: 700;\n                line-height: 1.2em;\n                margin-bottom: .5rem;\n\n                @media(min-width: 1200px) {\n                    font-size: 1.5rem;\n                }\n            }\n            /*p {\n                margin-bottom: 0 !important;\n            }*/\n            /*a {\n                color: white !important;\n                text-decoration: underline;\n            }*/\n\n            span {\n                white-space: pre;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
